import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { orders } from "../../../../../../redux/orders/action"
import { selectOrdersExportItem, selectOrdersListItems, selectOrdersPrintItem } from "../../../../../../redux/orders/selector";
import { selectListItems } from "../../../../../../redux/library/selector";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { settings } from "../../../../../../redux/settings/actions";
import GetQuote from "../../../../../../models/GetQuote";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import Popup from "../../../../../../common/components/popup";
import ModalExportComponent from "../components/modal-export-details";
import moment from "moment";

const ManagementOrders = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectOrdersListItems)
  const [pageSize, setPageSize] = useState(10);
  const [selectedItem, setSelectedItem] = useState<any>({})
  const [openModal, setOpenModal] = useState<any>(undefined);
  const exportDataDetails = useSelector(selectOrdersExportItem)
  const [exportsData, setExportsData] = useState<boolean>(false)
  const [isLoadingEnable, setIsLoadingEnable] = useState<boolean>(false)
  const orderInvoiceData = useSelector(selectOrdersPrintItem)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      }, {
        field: 'Message.InvoiceNumber', headerName: 'Invoice Number', searchField: 'InvoiceNumber', sortable: true, filter: true, filterType: 'text',
        isGeneratedPrintOrders: true
      },
      {
        field: 'Message.LogisticsOrderStatusId',
        headerName: 'Order Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.LogisticsOrderStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: false,
      },
      {
        field: 'Message.ShippingStatusId',
        headerName: 'Shipment Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.ShippingStatus, isRowColorDecider: true, isRowMenuSelect: false, anchorPosition: 'top-left' },
        sortable: true,
        filter: false,
      },
      // { field: 'Message.TrackingNumber', headerName: 'Eway Number', isGeneratedPDF: true },
      { field: 'Message.ShipmentPId', headerName: 'Order Id' },
      { field: 'Message.CustomerName', headerName: 'Customer Name', },
      { field: 'Message.TransporterName', headerName: 'Transporter Name' },
      { field: 'Message.AgentName', headerName: 'Agent Name' },
      { field: 'Message.AgentPhoneNo', headerName: 'Agent Phone no' },
      { field: 'Message.TrackingNumber', headerName: 'Tracking Number', sortable: false, filter: true },
      { field: 'Message.DeliveryDateUtc', headerName: 'Delivery Date', isOnlyDateValueFormat: true },
      { field: 'Message.CreatedOnUtc', headerName: 'Order Date', isDateValueFormat: true, },

    ]);
  }

  const fetchOrders = () => {
    dispatch(settings.set({ getQuote: 'close' }))
    dispatch(orders.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/list`, entity: 'order', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",

      }
    }))
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedItem({ ...selectedItem, [field]: event });
  }

  useEffect(() => {
    createColumnDefs()
    fetchOrders()
  }, [pageData, pageSize])

  const handleCargoAdd = () => {
    navigate('/management/booking/cargo')
  }
  const handleParcelAdd = () => {
    navigate('/management/booking/parcel')
  }
  const handleDelete = (data: any) => {
    dispatch(orders.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/delete`,
      entity: 'orders',
      jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              Id: data?.Message?.Id
            }

          }
        ]
      }
    })).then(() => {
      fetchOrders()
    });
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }
  const handleReloadData = () => {
    fetchOrders()
  }

  const handleExportOrder = () => {
    setOpenModal({
      id: 0
    });
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Parcel Order Booking</title>
          <path d="M11 22C10.1818 22 9.40019 21.6698 7.83693 21.0095C3.94564 19.3657 2 18.5438 2 17.1613C2 16.7742 2 10.0645 2 7M11 22L11 11.3548M11 22C11.7248 22 12.293 21.7409 13.5 21.2226M20 7V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M15 17.5H22M18.5 21L18.5 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M7.32592 9.69138L4.40472 8.27785C2.80157 7.5021 2 7.11423 2 6.5C2 5.88577 2.80157 5.4979 4.40472 4.72215L7.32592 3.30862C9.12883 2.43621 10.0303 2 11 2C11.9697 2 12.8712 2.4362 14.6741 3.30862L17.5953 4.72215C19.1984 5.4979 20 5.88577 20 6.5C20 7.11423 19.1984 7.5021 17.5953 8.27785L14.6741 9.69138C12.8712 10.5638 11.9697 11 11 11C10.0303 11 9.12883 10.5638 7.32592 9.69138Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M5 12L7 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M16 4L6 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleParcelAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Cargo Order Booking</title>
          <circle cx="17" cy="18" r="2" stroke="currentColor" stroke-width="1.5" />
          <circle cx="7" cy="18" r="2" stroke="currentColor" stroke-width="1.5" />
          <path d="M11 17H15M13.5 7H14.4429C15.7533 7 16.4086 7 16.9641 7.31452C17.5196 7.62904 17.89 8.20972 18.6308 9.37107C19.1502 10.1854 19.6955 10.7765 20.4622 11.3024C21.2341 11.8318 21.6012 12.0906 21.8049 12.506C22 12.9038 22 13.375 22 14.3173C22 15.5596 22 16.1808 21.651 16.5755C21.636 16.5925 21.6207 16.609 21.6049 16.625C21.2375 17 20.6594 17 19.503 17H19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M13 7L13.9942 9.48556C14.4813 10.7034 14.7249 11.3123 15.2328 11.6561C15.7407 12 16.3965 12 17.7081 12H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4.86957 17C3.51684 17 2.84048 17 2.42024 16.5607C2 16.1213 2 15.4142 2 14V7C2 5.58579 2 4.87868 2.42024 4.43934C2.84048 4 3.51684 4 4.86957 4H10.1304C11.4832 4 12.1595 4 12.5798 4.43934C13 4.87868 13 5.58579 13 7V17H8.69565" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleCargoAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="26" height="24">
          <title>Export Orders</title>
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-4-4z" fill="none" stroke="currentColor" stroke-width="2" />
          <path d="M12 10v6m-3-3l3 3 3-3" stroke="currentColor" stroke-width="2" />
        </svg>,
      callback: () => handleExportOrder(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Message.InvoiceNumber",
        FieldText: "Message.InvoiceNumber",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(orders.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/list`,
      entity: 'order',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }


  const launchPrintInvoice = (data: any) => {
    const windowGlobal: any = typeof window !== 'undefined' && window
    if (windowGlobal) {
      const windowProps = 'width=1000, height=750, menubar=no, resizable=yes, scrollbars=no, titlebar=no, toolbar=no, location=no'
      window.open(
        `${window.location.origin}/order/invoice/${data?.Message?.InvoiceNumber}`,
        '_blank',
        windowProps
      );
    }
  }
  const handleGeneratePrintOrdersInvoice = async (data: any) => {

    launchPrintInvoice(data);
  }
  const launchPdfInBrowser = (data: any) => {
    const windowGlobal: any = typeof window !== 'undefined' && window
    if (windowGlobal) {
      const windowProps = 'width=1000, height=750, menubar=no, resizable=yes, scrollbars=no, titlebar=no, toolbar=no, location=no'
      window.open(
        `${window.location.origin}/order/e-way/${data?.Message?.TrackingNumber}`,
        '_blank',
        windowProps
      );
    }
  }
  const handleGeneratePrintEWayBill = async (data: any) => {

    launchPdfInBrowser(data);
  }
  const closeModal = () => {
    setOpenModal(undefined)
    setSelectedItem('')
  }
  const handleSaveExportSubmit = async () => {
    await setIsLoadingEnable(true)
    await dispatch(orders.export({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/export-logistics-order`, entity: 'exportOrders', jsonData: {

        "Records": [
          {
            "context": {
            },
            "Message": selectedItem
          }
        ]

      }
    })).then(() => {
      setExportsData(true)
      setIsLoadingEnable(false)
    })

  };


  useEffect(() => {
    if (exportsData) {
      const blob1 = new Blob([exportDataDetails?.result], { type: 'multipart/form-data' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob1);
      const today = moment()
        .startOf('day' as moment.unitOfTime.StartOf)
        .format();
      const fileName = ` ${today}_Order.csv`;
      link.download = fileName;
      link.click();
      setExportsData(false)
      closeModal()
    }
  }, [exportsData])
  const ExportPopup = () => {

    const closeModal = () => {
      setOpenModal(undefined)
      setSelectedItem('')
    }

    return (
      <>
        {isLoadingEnable ? <PageLoader /> :
          <Popup onClose={closeModal}>
            <ModalExportComponent
              Close={closeModal}
              selectedItem={selectedItem}
              orderType={libraryData?.result?.LogisticsOrderType}
              handlePackageItemSubmit={handleSaveExportSubmit}
              handleInnerFormChange={handleInnerFormChange}

            />

          </Popup>}
      </>
    )
  }

  return (
    <>
      <GetQuote />
      {
        openModal ? <ExportPopup /> : <></>
      }
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          enableFilter={true}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          onGeneratePdfInvoice={handleGeneratePrintEWayBill}
          onGeneratePrintOrderInvoice={handleGeneratePrintOrdersInvoice}
          onSearch={handleSearch}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          additionButtons={additionButtons}
          onDelete={handleDelete}
          headingName="Orders" />
      }
    </>

  );
};

export default ManagementOrders;


